/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown>, date: NonNullable<unknown> }} Pc_Dl_About_P1Inputs */

const en_pc_dl_about_p1 = /** @type {(inputs: Pc_Dl_About_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft ${i?.version} was released by the ArtCraft team on ${i?.date}. The files below are hosted on the PdfCraft release page at github.com/storytold/pdfcraft/releases; PDFCraftTool.org only links to them, so what you install is exactly what ArtCraft published. Windows installers and executables are code-signed, and the Mac app is signed and notarized by Apple.`)
};

const zh_pc_dl_about_p1 = /** @type {(inputs: Pc_Dl_About_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft ${i?.version} 由 ArtCraft 团队于 ${i?.date} 发布。下面的文件托管在 PdfCraft 的 GitHub 发布页 github.com/storytold/pdfcraft/releases，PDFCraftTool.org 只提供链接，因此你安装的正是 ArtCraft 发布的原版。Windows 安装包和程序都经过代码签名，Mac 版经过 Apple 签名和公证。`)
};

/**
* | output |
* | --- |
* | "PdfCraft {version} was released by the ArtCraft team on {date}. The files below are hosted on the PdfCraft release page at github.com/storytold/pdfcraft/rele..." |
*
* @param {Pc_Dl_About_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_about_p1 = /** @type {((inputs: Pc_Dl_About_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_About_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_about_p1(inputs)
	return zh_pc_dl_about_p1(inputs)
});
export { pc_dl_about_p1 as "pc.dl.about_p1" }